/**
 * SBO terms of reactions drawn in reduced notation (Activity Flow). Unlike
 * process description reactions these describe an influence rather than a
 * transformation, so they are never reversible.
 */
const REDUCED_NOTATION_SBO_TERMS: ReadonlyArray<string> = [
  'SBO:0000171', // Positive influence
  'SBO:0000407', // Negative influence
  'SBO:0000411', // Reduced physical stimulation
  'SBO:0000632', // Reduced modulation
  'SBO:0000533', // Reduced trigger
  'SBO:0000172', // Unknown positive influence
  'SBO:0000169', // Unknown negative influence
  'SBO:0000631', // Unknown reduced modulation
  'SBO:0000170', // Unknown reduced physical stimulation
  'SBO:0000534', // Unknown reduced trigger
  'SBO:0000013', // Catalysis
  'SBO:0000537', // Inhibition
  'SBO:0000462', // Unknown catalysis
  'SBO:0000536', // Unknown inhibition
  'SBO:0000459', // Physical stimulation
  'SBO:0000594', // Modulation
  'SBO:0000461', // Trigger
];

export const isReducedNotationReaction = (sboTerm: string): boolean =>
  REDUCED_NOTATION_SBO_TERMS.includes(sboTerm);

export default REDUCED_NOTATION_SBO_TERMS;
